module.exports = __webpack_public_path__ + "img/dox-pair-success.21049981.gif";